const OFFER_BASE = "https://sho.tgntraff.com/click";
const DEFAULT_PID = "125";
const DEFAULT_OFFER_ID = "3347";

function readParam(sp, ls, keys) {
  for (const key of keys) {
    const fromUrl = sp && sp.get(key);
    if (fromUrl != null && fromUrl !== "") {
      return fromUrl;
    }
    const fromLs = ls && ls.getItem(key);
    if (fromLs != null && fromLs !== "") {
      return fromLs;
    }
  }
  return "";
}

/**
 * https://sho.tgntraff.com/click?pid=…&offer_id=3347&sub2=…&sub3=…
 * sub2 / sub3 беруться з query лендингу (і localStorage після першого візиту).
 */
export function buildOfferClickUrl() {
  const sp =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : null;
  const ls = typeof window !== "undefined" ? window.localStorage : null;

  const pid = readParam(sp, ls, ["pid", "id"]) || DEFAULT_PID;
  const offerId =
    readParam(sp, ls, ["offer_id", "offer"]) || DEFAULT_OFFER_ID;
  const sub2 = readParam(sp, ls, ["sub2", "sub_id_2"]);
  const sub3 = readParam(sp, ls, ["sub3", "sub_id_3"]);

  const q = new URLSearchParams();
  q.set("pid", pid);
  q.set("offer_id", offerId);
  if (sub2) {
    q.set("sub2", sub2);
  }
  if (sub3) {
    q.set("sub3", sub3);
  }

  return `${OFFER_BASE}?${q.toString()}`;
}
